<template>
  <div class="radio">
    <a href="javascript:;" :class="{ active: studentRelationShip === 'F' }" @click="changeChecked('F')">父（子/女）</a>
    <a href="javascript:;" :class="{ active: studentRelationShip === 'M' }" @click="changeChecked('M')">母（子/女）</a>
    <a href="javascript:;" :class="{ active: studentRelationShip === 'O' }" @click="changeChecked('O')">其他</a>
  </div>
</template>

<script>
export default {
  name: 'StudentRelationShip',
  props: {
    studentRelationShip: {
      type: String
    }
  },
  setup (props, { emit }) {
    const changeChecked = value => {
      emit('change', value)
    }
    return { changeChecked }
  }
}
</script>

<style lang="less" scoped>
.radio {
  height: 46px;
  display: flex;
  align-items: center;
  a {
    height: 30px;
    line-height: 30px;
    box-shadow: 0 0 1px #e4e4e4;
    padding: 0 20px;
    margin-right: 20px;
    color: #666;
    border-radius: 2px;
    position: relative;
    transition: all 0.3s;
    background: #fff;
    &:hover {
      box-shadow: 0 0 1px @themeColor;
    }
    &.active {
      background: @themeColor;
      border-color: @themeColor;
      color: #fff;
    }
  }
}
</style>
